// src/icons/svgs/strike-through.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgStrikeThrough = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "none", viewBox: "0 0 28 28", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { fill: "#343A40", d: "M5.833 14h16.334z" }),
  /* @__PURE__ */ jsx("path", { stroke: "#495057", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.56, d: "M5.833 14h16.334M18.667 7.583c-.265-.513-.871-.966-1.72-1.284C16.1 5.98 15.06 5.817 14 5.833h-1.167a4.083 4.083 0 0 0 0 8.167h2.334a4.083 4.083 0 0 1 0 8.167h-1.75c-1.06.016-2.1-.148-2.948-.466s-1.454-.771-1.719-1.284" })
] });
var ForwardRef = forwardRef(SvgStrikeThrough);
var strike_through_default = ForwardRef;
export {
  strike_through_default as TextStrikeThrough
};
